/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Standard_CeaInputs */



/**
* | output |
* | --- |
* | "CEA-608/708 closed captions" |
*
* @param {Embed_Captions_Local_Standard_CeaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_standard_cea = /** @type {((inputs?: Embed_Captions_Local_Standard_CeaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Standard_CeaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titres codés CEA-608/708")
	if (locale === "de") return /** @type {LocalizedString} */ ("CEA-608/708 Untertitel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitoli per CEA-608/708")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Субтитры CEA-608/708")
	if (locale === "es") return /** @type {LocalizedString} */ ("CEA-608/708 subtítulos cerrados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("CEA-608/708 隐藏式字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CEA-608/708 クローズドキャプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("CEA-608/708 क्लोज्ड कैप्शन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas ocultas CEA-608/708")
	return /** @type {LocalizedString} */ ("CEA-608/708 closed captions")
});